/* eslint-disable */
// Simplified presence demo without complex dependencies
import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
  Grid
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import eventService from '../services/eventService';

const SimplePresenceDemo = () => {
  const { user } = useAuth();
  const [status, setStatus] = useState('online');
  const [lastUpdate, setLastUpdate] = useState(null);

  const handleStatusChange = async (newStatus) => {
    if (!user?.id) return;
    
    try {
      await eventService.updatePresence(user.id, newStatus);
      setStatus(newStatus);
      setLastUpdate(new Date().toLocaleString());
    } catch (error) {
      console.error('Error updating presence:', error);
    }
  };

  if (!user) {
    return (
      <Alert severity="warning">
        Please sign in to test the presence system.
      </Alert>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        🟢 Simple Presence Test
      </Typography>
      
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Current Status: {status}
              </Typography>
              
              {lastUpdate && (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Last updated: {lastUpdate}
                </Typography>
              )}
              
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => handleStatusChange('online')}
                >
                  Online
                </Button>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={() => handleStatusChange('away')}
                >
                  Away
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleStatusChange('offline')}
                >
                  Offline
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SimplePresenceDemo;